<ng-container *transloco="let t">
  <main class="input">
    <header class="header" *ngIf="!allwaysApplicable">
      <mat-slide-toggle
        [(ngModel)]="inspection.isApplicable"
        [color]="inspection.isPassed ? 'primary' : 'warn'"
        *ngIf="!(readonly || printPreview)"
        (change)="onChange()"
      >
        <span
          class="title"
          [class.section]="inspection.isTitle"
          [class.applicable]="inspection.isApplicable"
          [class.error]="inspection.isApplicable && !inspection.isPassed"
          ><span>{{ inspection.section }} </span
          ><span style="white-space: pre-line">{{ inspection.title }}</span>
        </span>
      </mat-slide-toggle>
      <button
        style="margin-right: 10px; margin-top: -8px; float: left"
        mat-icon-button
        color="primary"
        (click)="showNotes = true"
        *ngIf="
          !printPreview &&
          !readonly &&
          inspection.isTitle &&
          !showNotes &&
          inspection.notes?.length === 0
        "
      >
        <mat-icon style="font-size: 18px">note_add</mat-icon>
      </button>
      <span
        class="title"
        [class.section]="inspection.isTitle"
        [class.applicable]="inspection.isApplicable"
        [class.error]="inspection.isApplicable && !inspection.isPassed"
        *ngIf="readonly || printPreview"
      >
        <span *ngIf="inspection.section">{{ inspection.section }} </span
        ><span style="white-space: pre-line">{{ inspection.title }}</span></span
      >
    </header>

    <div
      *ngIf="
        (allwaysApplicable || inspection.isApplicable || printPreview) &&
        !inspection.isTitle
      "
      class="details"
      [style.margin-right]="!(readonly || printPreview) ? '45px' : '0'"
    >
      <section>
        <ng-content></ng-content>
      </section>
      <section *ngIf="!printPreview && !hideConclusion">
        <mat-radio-group
          aria-label="Select an option"
          [(ngModel)]="inspection.isPassed"
          [disabled]="readonly || printPreview"
          (change)="onChange()"
        >
          <mat-radio-button [value]="true">{{
            t('inspection.fields.case:suitable')
          }}</mat-radio-button>
          <mat-radio-button [value]="false" color="warn">{{
            t('inspection.fields.case:notSuitable')
          }}</mat-radio-button>
          <mat-radio-button *ngIf="printPreview" checked="false">{{
            t('inspection.fields.case:notApplicable')
          }}</mat-radio-button>
        </mat-radio-group>
      </section>
      <section *ngIf="printPreview && !hideConclusion">
        <mat-radio-group disabled="true">
          <mat-radio-button
            value="true"
            [checked]="inspection.isPassed && inspection.isApplicable"
            >{{ t('inspection.fields.case:suitable') }}</mat-radio-button
          >
          <mat-radio-button
            value="false"
            [checked]="!inspection.isPassed && inspection.isApplicable"
            >{{ t('inspection.fields.case:notSuitable') }}</mat-radio-button
          >
          <mat-radio-button value="else" [checked]="!inspection.isApplicable">{{
            t('inspection.fields.case:notApplicable')
          }}</mat-radio-button>
        </mat-radio-group>
      </section>
      <section>
        <authority-labs-check-notes
          *ngIf="!multiNote && !hideNotes"
          [notes]="inspection.notes"
          [printPreview]="printPreview"
          [readonly]="readonly"
          [type]="inspection.title"
          [fieldSection]="fieldSection"
          [fieldTitle]="inspection.title"
          (dataChange)="onChange()"
        ></authority-labs-check-notes>

        <authority-labs-check-summary-notes
          *ngIf="multiNote && !hideNotes"
          [notes]="inspection.multiNotes"
          [printPreview]="printPreview"
          [readonly]="readonly"
          [type]="inspection.title"
          (dataChange)="onChange()"
        ></authority-labs-check-summary-notes>
      </section>
    </div>

    <div
      *ngIf="(inspection.isTitle && inspection.notes?.length > 0) || showNotes"
      class="details"
      [style.margin-right]="!(readonly || printPreview) ? '45px' : '0'"
    >
      <section>
        <authority-labs-check-notes
          *ngIf="!multiNote"
          [notes]="inspection.notes"
          [printPreview]="printPreview"
          [readonly]="readonly"
          [type]="inspection.title"
          [fieldSection]="fieldSection"
          [fieldTitle]="inspection.title"
          (dataChange)="onChange()"
        ></authority-labs-check-notes>
      </section>
    </div>
  </main>
</ng-container>
